import script from "./MapaUbicacion.vue?vue&type=script&setup=true&lang=js"
export * from "./MapaUbicacion.vue?vue&type=script&setup=true&lang=js"

import "./MapaUbicacion.vue?vue&type=style&index=0&id=78088259&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78088259"]])

export default __exports__